var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImpo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.52,
    height: 31.52,
    viewBox: "0 0 31.52 31.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1695",
    "data-name": "Raggruppa 1695",
    transform: "translate(-65.469 -65.469)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_127",
    "data-name": "Ellisse 127",
    cx: 5.288,
    cy: 5.288,
    r: 5.288,
    transform: "translate(75.942 75.942)",
    fill: "none",
    stroke: "#424242",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2927",
    "data-name": "Tracciato 2927",
    d: "M79.171,68.115a2.11,2.11,0,0,1,4.117,0,3.816,3.816,0,0,0,5.76,2.386,2.11,2.11,0,0,1,2.911,2.911,3.816,3.816,0,0,0,2.386,5.76,2.11,2.11,0,0,1,0,4.117,3.816,3.816,0,0,0-2.386,5.76,2.11,2.11,0,0,1-2.911,2.911,3.816,3.816,0,0,0-5.76,2.386,2.11,2.11,0,0,1-4.117,0,3.816,3.816,0,0,0-5.76-2.386A2.11,2.11,0,0,1,70.5,89.048a3.816,3.816,0,0,0-2.386-5.76,2.11,2.11,0,0,1,0-4.117,3.816,3.816,0,0,0,2.386-5.76A2.11,2.11,0,0,1,73.411,70.5,3.816,3.816,0,0,0,79.171,68.115Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#424242",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpo);
export default __webpack_public_path__ + "static/media/impo.31a2cfe6b619a65dc43d5fda2349842a.svg";
export { ForwardRef as ReactComponent };